import { Group, Heading, File } from '@ingeniorforeningen/figurine-core';
import { CaseDocument, FilesTexts } from '../../types';
import { getCaseDocument } from '../../api/services/caseDetails';
import { stripText } from '../../helpers/textsHelpers';

const ShowFileRow = (file: CaseDocument, caseId: number) => {
  const handleOnClick = () => getCaseDocument(caseId, file.id, file.fileName);

  return (
    <File
      cypress="caseFile"
      key={file.id}
      iconName="Download"
      filename={file.fileName}
      onClick={handleOnClick}
      variant={'transparent'}
      py={0}
      pl={0}
    />
  );
};

type CaseFilesProps = {
  caseId: number;
  caseDocuments: CaseDocument[];
  texts: FilesTexts;
};

const CaseFiles = ({ caseId, caseDocuments, texts }: CaseFilesProps) => {
  return (
    <>
      <Group p="xl" noWrap align="center">
        <Heading cypress="caseFilesHeader" type="h3" text={stripText(texts.files)} />
      </Group>
      <Group p="xl" pt={0} spacing="sm" direction="column">
        {caseDocuments.map((file) => ShowFileRow(file, caseId))}
      </Group>
    </>
  );
};

export default CaseFiles;
